import { motion } from 'framer-motion';

export const Card = ({ 
  children, 
  className = '', 
  interactive = false,
  onClick,
  ...props 
}) => {
  const interactiveClass = interactive ? 'cursor-pointer' : '';
  
  return (
    <motion.div
      className={`card ${interactiveClass} ${className}`}
      initial={{ opacity: 0, y: 24, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.45, ease: 'easeOut' }}
      whileHover={interactive ? { y: -8, scale: 1.02, rotate: -0.3 } : { y: -4 }}
      onClick={onClick}
      whileTap={interactive ? { scale: 0.98, rotate: 0.3 } : {}}
      {...props}
    >
      {children}
    </motion.div>
  );
};
